<template>
    <TotemSelect
        :options="authorizationOptions"
        :placeholder="$t('CourseListFilter.authorization')"
        @input="selectAuthorization"
        class="filter-select"
        ref="selectAuthorization"
        v-model="selectedAuthorization"
    />
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'AuthorizationFilter',
        props: {
            courseList: Array
        },
        computed: {
            ...mapGetters({
                selectedAuthorization: 'CourseFilter/getSelectedAuthorization'
            }),
            authorizationOptions () {
                let certs = this.courseList.reduce((certs, item) => {
                    if (item.certifiedBy) {
                        item.certifiedBy.forEach(({ label }) => certs.add(label))
                    }

                    if (item.authorizationPoints) {
                        item.authorizationPoints.forEach(({ authorizationName }) => certs.add(authorizationName))
                    }

                    if (item.durations) {
                        item.durations.forEach(({ category }) => certs.add(category))
                    }

                    return certs
                }, new Set())

                return Array.from(certs).map(el => ({ label: el, cert: el }))
            },
        },
        methods: {
            filterByAuthorization (data) {
                if (this.selectedAuthorization === null) {
                    return data
                }
                if (this.selectedAuthorization.cert === null) {
                    return data.filter(course => !course.certifiedBy || course.certifiedBy.length === 0)
                }
                return data.filter(course => {
                    if (course.authorizationPoints) {
                        return course.authorizationPoints.find(el => el.authorizationName === this.selectedAuthorization.label)
                    }
                    if (course.certificate?.durations) {
                        return course.certificate.durations.find(el => el.category === this.selectedAuthorization.label)
                    }
                    if (course.entityType === 'learningPath') {
                        // eslint-disable-next-line no-unused-vars
                        for (const courseCertificate of course.certificate.courseCertificates) {
                            return courseCertificate.durations.find(el => el.category === this.selectedAuthorization.label)
                        }
                    }
                    if (course.durations && course.durations.length > 0) {
                        return course.durations.find(el => el.category === this.selectedAuthorization.label)
                    }
                    if (course.certs && course.certs.length > 0) {
                        return course.certs.find(cert => cert === this.selectedAuthorization.label)
                    }
                    if (course.certifiedBy.length === 0 && course.durations) {
                        return course.durations && course.durations.find(el => el.category === this.selectedAuthorization.label)
                    }
                    return course.certifiedBy && course.certifiedBy.find(el => el.label === this.selectedAuthorization.label)
                })
            },
            selectAuthorization (option) {
                this.$store.dispatch('CourseFilter/selectAuthorization', option)
            },
            clear () {
                this.$refs.selectAuthorization.clear()
            }
        }
    }
</script>
